var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fee-card" },
    [
      _vm.showTitle
        ? _c("van-cell", {
            attrs: { center: "", title: _vm.title, border: false },
            scopedSlots: _vm._u(
              [
                {
                  key: "icon",
                  fn: function() {
                    return [
                      _c("div", { staticClass: "left-icon" }, [_vm._v("|")])
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2465796413
            )
          })
        : _vm._e(),
      _c(
        "van-grid",
        { attrs: { border: false, "column-num": _vm.columnNums } },
        _vm._l(_vm.listArr, function(item, index) {
          return _c("van-grid-item", {
            key: index,
            on: {
              click: function($event) {
                return _vm.handleItemClick(item)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "icon",
                  fn: function() {
                    return [
                      _c("div", { staticClass: "fee-item-image-wrapper" }, [
                        _vm.$utils.isNotEmpty(item.src)
                          ? _c("div", { staticClass: "fee-item-icon-size" }, [
                              _c("img", { attrs: { src: item.src } })
                            ])
                          : _c("div", {
                              staticClass: "fee-item-icon-size",
                              class: _vm.feeItemImageClass(item)
                            })
                      ])
                    ]
                  },
                  proxy: true
                },
                {
                  key: "text",
                  fn: function() {
                    return [
                      _c(
                        "span",
                        {
                          staticClass:
                            "van-grid-item__text van-multi-ellipsis--l2"
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }